import http from "../app/httpService";
import uuid from "react-uuid";

const apiEndpoint =
  process.env.REACT_APP_MARKET_API + "MarketPriceDriverCombination/";

export async function getMarketPriceDriverCombinations(marketId) {
  const { data: combinations } = await http.get(apiEndpoint + "Market/" + marketId);
  return combinations || [];
}

export async function addMarketPriceDriverCombination(combination) {
  const payload = {
    ...combination,
    eventId: combination.eventId || uuid(),
  };
  const { data: savedCombination } = await http.post(apiEndpoint, payload);
  return savedCombination;
}

export async function updateMarketPriceDriverCombination(combination) {
  const payload = {
    ...combination,
    eventId: combination.eventId || uuid(),
  };
  const { data: updatedCombination } = await http.put(apiEndpoint, payload);
  return updatedCombination;
}

export async function updateMarketPriceDriverCombinationCore(
  combinationId,
  isCore
) {
  const payload = {
    combinationId: combinationId,
    isCore: isCore,
    eventId: uuid(),
  };
  const { data: updatedCombination } = await http.put(apiEndpoint + "Core", payload);
  return updatedCombination;
}

export async function deactivateMarketPriceDriverCombination(combinationId) {
  const payload = {
    eventId: uuid(),
  };
  const { data: updatedCombination } = await http.put(
    apiEndpoint + "Deactivate/" + combinationId,
    payload
  );
  return updatedCombination;
}
